import React from "react";

export default function PharmacyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-9 w-9 hover:fill-white"
      viewBox="0 0 43 44"
      fill="none"
    >
      <rect
        x="5.375"
        y="7.63031"
        width="31.5513"
        height="4.47917"
        rx="1.18"
        className="fill-dpurple hover:fill-white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.91457 15.4911C8.27179 15.1339 8.75766 14.9354 9.26282 14.9402H33.0562C33.5613 14.9354 34.0472 15.1339 34.4044 15.4911C34.7616 15.8483 34.9602 16.3342 34.9553 16.8394V32.5523C34.9649 33.8781 34.4473 35.1533 33.5166 36.0975C32.5859 37.0417 31.3182 37.5774 29.9924 37.5869H12.3266C11.0008 37.5774 9.73311 37.0417 8.80238 36.0975C7.87164 35.1533 7.35412 33.8781 7.36365 32.5523V16.8394C7.35882 16.3342 7.55736 15.8483 7.91457 15.4911ZM16.8775 23.5582H25.3879H25.4416C25.9537 23.5582 26.4269 23.285 26.6829 22.8415C26.939 22.398 26.939 21.8516 26.6829 21.4082C26.4269 20.9647 25.9537 20.6915 25.4416 20.6915H16.8775C16.0859 20.6915 15.4441 21.3332 15.4441 22.1248C15.4441 22.9164 16.0859 23.5582 16.8775 23.5582Z"
        fill="#45486E"
      />
    </svg>
  );
}
